import React from 'react';
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';

function SSOCallback() {
  return (
    <AuthenticateWithRedirectCallback
      signUpForceRedirectUrl="/auth/sso/success"
      signInForceRedirectUrl="/auth/sso/success"
    />
  );
}

export default SSOCallback;
